import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthService } from '@chefami-monorepo/data-access';

/**
 * Blocks authenticated users from accessing checkout onboarding routes.
 * Logged-in users are redirected to account page.
 */
export const guestOnlyGuard: CanActivateFn = () => {
  const auth = inject(AuthService);

  if (!auth.isLoggedIn()) {
    return true;
  }

  const accountUrl = auth.siteInfo()?.account_url || '/';
  if (typeof window !== 'undefined') {
    window.location.href = accountUrl;
  }
  return false;
};
